import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { AdminApi, GameCategoryApi } from "@lbsdk/*";

@Injectable({
  providedIn: "root",
})
export class PushNotificationsService implements Resolve<any> {
  selectedMenuItem: any;
  categories: any[];
  onCategoriesChanged: BehaviorSubject<any> = new BehaviorSubject({});
  privateGames: any[];
  onPrivateGamesChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(
    private _gameCategoryApi: GameCategoryApi,
    private _adminApi: AdminApi
  ) {}

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([
        this.getGameCategoriesWithPlayers(),
        this.getPrivateGamesWithPlayers(),
      ]).then(() => {
        resolve();
      }, reject);
    });
  }

  getPrivateGamesWithPlayers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._gameCategoryApi
        .getPrivateGameWithPlayers()
        .subscribe((privateGames) => {
          this.privateGames = privateGames;
          this.onPrivateGamesChanged.next(privateGames);
          resolve(this.privateGames);
        });
    });
  }

  getGameCategoriesWithPlayers(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._gameCategoryApi
        .getGameCategoriesWithPlayers()
        .subscribe((categories) => {
          this.categories = categories;
          this.onCategoriesChanged.next(categories);
          resolve(categories);
        }, reject);
    });
  }

  sendNotification(players, notification): Promise<any> {
    return new Promise((resolve, reject) => {
      this._gameCategoryApi
        .sendNotification(players, notification)
        .subscribe((res) => {
          resolve(res);
        }, reject);
    });
  }

  notifyAll(notification): Promise<any> {
    return new Promise((resolve, reject) => {
      this._adminApi.notifyAll(notification).subscribe((res) => {
        resolve(res);
      }, reject);
    });
  }
}
